/**
 * @file Frontend module — index.tsx.
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Inject Century Gothic font-face rules via style tag
const fontStyle = document.createElement('style');
fontStyle.textContent = `
  @font-face {
    font-family: 'Century Gothic';
    src: url('${process.env.PUBLIC_URL}/fonts/CenturyGothic.ttf') format('truetype');
    font-weight: 400;
    font-style: normal;
    font-display: swap;
  }
  
  @font-face {
    font-family: 'Century Gothic';
    src: url('${process.env.PUBLIC_URL}/fonts/CenturyGothicBold.ttf') format('truetype');
    font-weight: 700;
    font-style: normal;
    font-display: swap;
  }
`;
document.head.appendChild(fontStyle);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
